import React from "react";
import { SimpleBarChartComponent } from "./base/barChart";
import { FunctionalGroupData, TailLengthData } from "./types";

interface FunctionalGroupsSectionProps {
  functionalGroups: FunctionalGroupData[];
  nitrogenDistribution: FunctionalGroupData[];
  saturationData: FunctionalGroupData[];
  tailLengthData: TailLengthData[];
}

const FunctionalGroupsSection: React.FC<FunctionalGroupsSectionProps> = ({
  functionalGroups,
  nitrogenDistribution,
  saturationData,
  tailLengthData,
}) => {
  const formattedFunctionalGroups = functionalGroups.map((item) => ({
    name: item.category,
    value: item.count,
  }));

  const formattedNitrogenData = nitrogenDistribution.map((item) => ({
    name: item.category,
    value: item.count,
  }));

  const formattedSaturationData = saturationData.map((item) => ({
    name: item.category,
    value: item.count,
  }));

  const formattedTailLengthData = tailLengthData.map((item) => ({
    name: item.length,
    value: item.count,
  }));

  return (
    <div className="mb-8 bg-white rounded-lg shadow-md">
      <div className="p-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800">
          Functional Groups
        </h2>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 gap-6 mb-4 md:grid-cols-2">
          <div>
            <SimpleBarChartComponent
              data={formattedFunctionalGroups}
              title="Functional Groups"
              yAxisLabel="Count"
            />
          </div>
          <div>
            <SimpleBarChartComponent
              data={formattedNitrogenData}
              title="Number of Nitrogens"
              yAxisLabel="Count"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2">
          <div>
            <SimpleBarChartComponent
              data={formattedTailLengthData}
              title="Longest Tail Length"
              xAxisLabel="Count"
              yAxisLabel="Length"
            />
          </div>
          <div>
            <SimpleBarChartComponent
              data={formattedSaturationData}
              title="Tail Saturation"
              yAxisLabel="Count"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunctionalGroupsSection;
